import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCalendarX",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, i, h, _, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--calendar-x"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Calendar X",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M1.44 1.94A1.5 1.5 0 0 1 2.5 1.5h1V1a.5.5 0 0 1 1 0v.5h3V1a.5.5 0 0 1 1 0v.5h1A1.5 1.5 0 0 1 11 3v3a.5.5 0 0 1-1 0v-.5H2V10c0 .274.226.5.5.5h3.75a.5.5 0 0 1 0 1H2.5c-.826 0-1.5-.674-1.5-1.5V3c0-.398.158-.78.44-1.06Zm8.414.706A.5.5 0 0 1 10 3v1.5H2V3a.5.5 0 0 1 .5-.5h1V3a.5.5 0 0 0 1 0v-.5h3V3a.5.5 0 0 0 1 0v-.5h1a.5.5 0 0 1 .354.146Z",
      fill: "currentColor"
    }, null, -1),
    l("path", {
      d: "M8.854 8.146a.5.5 0 1 0-.708.708l.897.896-.897.896a.5.5 0 0 0 .708.708l.896-.897.896.897a.5.5 0 0 0 .708-.708l-.897-.896.897-.896a.5.5 0 0 0-.708-.708l-.896.897-.896-.897Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const C = /* @__PURE__ */ s(c, [["render", m]]);
export {
  C as default
};
//# sourceMappingURL=calendar-x.js.map
